import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FreelancerLayout from "../../layouts/FreelancerLayout";
import {
  fetchOpenTalentJobs,
  fetchfreelancerProfile,
  applyOpenTalentJob,
  saveOpenTalentJob,
  fetchSavedOpenTalentJobs,
  fetchAppliedOpenTalentJobs,
  reviewOpenTalentJob,
  scheduleOpenTalentInterviewAction,
} from "../../redux/features/find-a-job/actions/authAction";
import Loader from "../../components/loader";
import { pipViewDate2 } from "../../utils/pip";
import FreelancerJobDetailsModal from "../../components/Modals/common/FreelancerJobDetailsModal";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import PdfOrImageUploader from "../../components/pdfImage uploader";
import { Formik } from "formik";
import ErrorMessage from "../../components/form/ErrorMessage";
import { applyJobSchema } from "../../utils/schema";
import { useNavigate } from "react-router-dom";
import { findAJobPaths } from "../../routes/find-a-job";
const MyJob = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    subLoading,
    openTalentJobs,
    savedJobs,
    appliedJobs,
    freelancerProfileData,
    isLoading,
  } = useSelector(
    (state) => state.freelancer.auth
  );
  const [activeJob, setActiveJob] = useState(null);
  const [activeApplyJob, setActiveApplyJob] = useState(null);
  const [activeTab, setActiveTab] = useState("for_me");
  const normalizeCompanyName = (value) =>
    String(value || "").trim().toLowerCase();
  const normalizePhoneValue = (value) => {
    if (!value) return "";
    const trimmed = String(value).trim();
    if (!trimmed) return "";
    if (trimmed.startsWith("+")) return trimmed;
    const digits = trimmed.replace(/\D/g, "");
    if (!digits) return "";
    return `+${digits}`;
  };
  const experiencesList = Array.isArray(freelancerProfileData?.experiences)
    ? freelancerProfileData.experiences
    : [];
  const mostRecentExperience = experiencesList.find(
    (item) => item?.currently_working
  ) ||
    [...experiencesList].sort((a, b) => {
      const dateA = new Date(a?.start_date || a?.created_at || 0).getTime();
      const dateB = new Date(b?.start_date || b?.created_at || 0).getTime();
      return dateB - dateA;
    })[0];
  const mostRecentCompany =
    mostRecentExperience?.company_name ||
    freelancerProfileData?.open_talent?.company_name ||
    freelancerProfileData?.open_talent?.current_company ||
    "";
  const workOptions = [
    { label: "Remote", value: "Remote Freelance" },
    { label: "Full-time", value: "Full-time Freelance" },
    { label: "Part-time", value: "Part-time Freelance" },
    { label: "Hybrid", value: "Hybrid Freelance" },
    { label: "On-Site", value: "On-Site Freelance" },
    { label: "Project-Based", value: "Project Based" },
  ];
  const activeJobId = activeJob?.id || activeJob?.job_id;
  const similarJobs =
    activeJob && Array.isArray(openTalentJobs)
      ? openTalentJobs.filter(
        (item) =>
          item?.id !== activeJobId &&
          item?.job_id !== activeJobId &&
          normalizeCompanyName(item?.company_name) ===
          normalizeCompanyName(activeJob?.company_name)
      )
      : [];
  const jobsForMe = Array.isArray(openTalentJobs)
    ? openTalentJobs.filter(
      (job) =>
        String(job?.status || "").toLowerCase() !== "applied" &&
        !job?.is_applied
    )
    : [];
  const isJobSaved = (job) => {
    const value = job?.is_saved;
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") return value.toLowerCase() === "true";
    return false;
  };

  useEffect(() => {
    dispatch(fetchOpenTalentJobs());
    dispatch(fetchSavedOpenTalentJobs());
    dispatch(fetchAppliedOpenTalentJobs());
    dispatch(fetchfreelancerProfile());
  }, [dispatch]);

  const getApplyInitialValues = () => {
    const fullName =
      freelancerProfileData?.full_name ||
      `${freelancerProfileData?.first_name || ""} ${freelancerProfileData?.last_name || ""
        }`.trim();
    const currentPosition =
      mostRecentExperience?.job_title ||
      freelancerProfileData?.open_talent?.primary_role ||
      freelancerProfileData?.open_talent?.talent_role ||
      "";
    const cvValue =
      freelancerProfileData?.cv || freelancerProfileData?.open_talent?.cv;
    const existingCvList = Array.isArray(cvValue)
      ? cvValue
      : cvValue
        ? [cvValue]
        : [];
    return {
      full_name: fullName || "",
      email: freelancerProfileData?.email || "",
      phone_number: normalizePhoneValue(
        freelancerProfileData?.phone_number || ""
      ),
      expected_salary:
        freelancerProfileData?.open_talent?.salary_preference || "",
      work_type: freelancerProfileData?.open_talent?.availability || "",
      current_position: currentPosition,
      linkedin_url:
        freelancerProfileData?.open_talent?.linkedin_profile ||
        freelancerProfileData?.linkedin_profile ||
        "",
      portfolio_url:
        freelancerProfileData?.open_talent?.website_or_portfolio ||
        freelancerProfileData?.open_talent?.portfolio ||
        "",
      cover_letter: "",
      resume_files: existingCvList,
    };
  };

  const resolveResumeValue = (resumeFiles = []) => {
    const firstItem = resumeFiles?.[0];
    if (!firstItem) return null;
    if (firstItem instanceof File) return firstItem;
    if (typeof firstItem === "string") return firstItem;
    if (firstItem?.file instanceof File) return firstItem.file;
    if (typeof firstItem?.file === "string") return firstItem.file;
    if (typeof firstItem?.url === "string") return firstItem.url;
    if (typeof firstItem?.preview === "string") return firstItem.preview;
    return null;
  };

  const handleSubmitApplyJob = (values) => {
    if (!activeApplyJob) return;
    const formData = new FormData();
    formData.append("job_id", activeApplyJob?.id || "");
    formData.append("full_name", values.full_name);
    formData.append("email", values.email);
    formData.append("phone_number", values.phone_number);
    formData.append("expected_salary", values.expected_salary);
    formData.append("work_type", values.work_type);
    formData.append("current_position", values.current_position);
    formData.append("linkedin_url", values.linkedin_url);
    formData.append("portfolio_url", values.portfolio_url);
    formData.append("cover_letter", values.cover_letter);
    const resumeValue = resolveResumeValue(values.resume_files);
    if (resumeValue) {
      formData.append("resume_url", resumeValue);
    }
    dispatch(
      applyOpenTalentJob({
        payload: formData,
        callback: (response) => {
          if (response?.success) {
            dispatch(fetchOpenTalentJobs());
            dispatch(fetchSavedOpenTalentJobs());
            dispatch(fetchAppliedOpenTalentJobs());
            dispatch(fetchfreelancerProfile());
            setActiveApplyJob(null);
            setActiveJob(null);
          }
        },
      })
    );
  };

  const handleSaveJob = (job) => {
    const jobId = job?.id || job?.job_id;
    if (!jobId) return;
    dispatch(
      saveOpenTalentJob({
        payload: { job_id: jobId },
        callback: (response) => {
          if (response?.success) {
            dispatch(fetchOpenTalentJobs());
            dispatch(fetchSavedOpenTalentJobs());
            dispatch(fetchAppliedOpenTalentJobs());
            setActiveJob(null);
          }
        },
      })
    );
  };

  const handleViewJob = (job) => {
    const jobId = job?.id || job?.job_id;
    if (!jobId) return;
    dispatch(
      reviewOpenTalentJob({
        payload: { job_id: jobId },
        callback: () => {
          setActiveJob(job);
        },
      })
    );
  };

  const handleScheduleAction = (job, action) => {
    if (!job?.applied_id || !action) return;
    dispatch(
      scheduleOpenTalentInterviewAction({
        params: job.applied_id,
        payload: { action },
        callback: (response) => {
          if (response?.success) {
            dispatch(fetchAppliedOpenTalentJobs());
            dispatch(fetchOpenTalentJobs());
            dispatch(fetchSavedOpenTalentJobs());
            setActiveJob(null);
          }
        },
      })
    );
  };

  if (subLoading || (isLoading && !activeApplyJob)) {
    return <Loader />;
  }
  return (
    <div>
      <FreelancerLayout>
        <div className="ct_px_40 my-5">
          <div className="container-fluid">
            <div className="row gx-5">
              <div className="col-xxl-3 col-xl-4 col-lg-4 mb-4">
                <div>
                  <div className="ct_outline_bg ct_p_20 ct_box_shadow_card_1 ct_border_radius_10">
                    <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_10">
                      <div>
                        <img
                          src={
                            freelancerProfileData?.profile_image ||
                            "/assets/img/user_profile.png"
                          }
                          className="ct_img_56"
                        />
                      </div>
                    </div>
                    <h6 className="ct_fs_16 ct_darkblue_text mb-1">
                      {freelancerProfileData?.full_name ||
                        `${freelancerProfileData?.first_name || ""} ${freelancerProfileData?.last_name || ""
                          }`.trim() ||
                        "#N/A"}
                    </h6>
                    <p className="ct_fs_14">
                      {freelancerProfileData?.open_talent?.location ||
                        [freelancerProfileData?.open_talent?.city,
                        freelancerProfileData?.open_talent?.state,
                        freelancerProfileData?.open_talent?.country]
                          .filter(Boolean)
                          .join(", ") ||
                        freelancerProfileData?.location ||
                        "#N/A"}
                    </p>
                    <ul className="ct_mb_16">
                      {mostRecentCompany &&
                        <li className="d-flex align-items-center gap-2 justify-content-between">
                          <p className="mb-0 ct_fs_14 ct_grey_text ct_white_nowrap">
                            Most Recent Job
                          </p>
                          <p className="mb-0 ct_fs_14 ct_grey_text text-truncate ct_darkblue_text">
                            {mostRecentCompany || "#N/A"}
                          </p>
                        </li>
                      }
                      <li className="d-flex align-items-center gap-2 justify-content-between ct_mt_16">
                        <p className="mb-0 ct_fs_14 ct_grey_text ct_white_nowrap">
                          Work Experience
                        </p>
                        <p className="mb-0 ct_fs_14 ct_grey_text text-truncate ct_darkblue_text">
                          {freelancerProfileData?.open_talent
                            ?.years_of_experience ||
                            freelancerProfileData?.open_talent?.experience ||
                            "#N/A"}
                        </p>
                      </li>
                    </ul>
                    <div className="d-flex align-items-center gap-2">
                      <img src="../assets/img/grey_mail_icon.svg" />
                      <p className="mb-0 ct_fs_14 ct_grey_text">
                        {freelancerProfileData?.email || "#N/A"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center ct_mt_10 gap-2">
                      <img src="../assets/img/grey_phon_icon.svg" />
                      <p className="mb-0 ct_fs_14 ct_grey_text">
                        {freelancerProfileData?.phone_number || "#N/A"}
                      </p>
                    </div>

                    <div className="ct_mt_27">
                      <button className="ct_yellow_btn ct_h_37 w-100 ct_fs_14" onClick={() => navigate(findAJobPaths?.EditProfile)}>
                        Edit Profile
                      </button>
                    </div>
                  </div>

                  <div className="ct_mt_40">
                    <ul>
                      <li>
                        <div
                          className="ct_outline_bg ct_box_shadow_card_1 ct_p_10 ct_border_radius_10 ct_cursor_pointer"
                          style={{
                            backgroundColor: "#FB8500",
                            border: "1px solid #E1E4EA",
                          }}
                          onClick={() => setActiveTab("for_me")}
                        >
                          <p className="mb-0 ct_fs_16 ct_darkblue_text">
                            Jobs for me ({jobsForMe?.length || 0})
                          </p>
                        </div>
                      </li>
                      <li className="mt-4">
                        <div
                          className="ct_outline_bg ct_box_shadow_card_1 ct_p_10 ct_border_radius_10 ct_cursor_pointer"
                          style={{
                            backgroundColor: "#FFB703",
                            border: "1px solid #E1E4EA",
                          }}
                          onClick={() => setActiveTab("applied")}
                        >
                          <p className="mb-0 ct_fs_16 ct_darkblue_text">
                            Jobs Applied ({appliedJobs?.length || 0})
                          </p>
                        </div>
                      </li>
                      <li className="mt-4">
                        <div
                          className="ct_outline_bg ct_box_shadow_card_1 ct_p_10 ct_border_radius_10 ct_cursor_pointer"
                          style={{
                            backgroundColor: "#8ECAE6",
                            border: "1px solid #E1E4EA",
                          }}
                          onClick={() => setActiveTab("saved")}
                        >
                          <p className="mb-0 ct_fs_16 ct_darkblue_text">
                            Saved Jobs ({savedJobs?.length || 0})
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="ct_mt_40 ct_outline_bg ct_box_shadow_card_1 ct_border_radius_10 ct_p_20 text-center">
                    <h5 className="ct_fs_16 ct_darkblue_text ct_mb_16">
                      Don’t Miss Any Update
                    </h5>
                    <p
                      className="ct_fs_14 ct_grey_text mb-0 mx-auto"
                      style={{ maxWidth: "253px" }}
                    >
                      Be the first to know about upcoming events, remote work,
                      courses, and everything about hiring and working better
                    </p>
                    <div className="mt-4">
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control ct_input  ct_h_37"
                          placeholder="Enter Email"
                        />
                      </div>
                      <div className="ct_mt_20">
                        <button className="ct_yellow_btn ct_darkblue_btn ct_fs_14 w-100">
                          Subscribe
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-8 col-xl-7 col-lg-7 mb-4">
                <div className="ct_outline_bg ct_p_40 ct_box_shadow_card_1 ct_border_radius_10 h-100">
                  <ul className="d-flex align-items-center gap-4 ct_job_tabs">
                    <li
                      className={`ct_grey_text ct_darkblue_text ${activeTab === "for_me" ? "ct_fw_600 active" : ""
                        }`}
                      onClick={() => setActiveTab("for_me")}
                      style={{ cursor: "pointer" }}
                    >
                      Jobs for me{" "}
                    </li>
                    <li
                      className={`ct_grey_text ct_darkblue_text ${activeTab === "applied" ? "ct_fw_600 active" : ""
                        }`}
                      onClick={() => setActiveTab("applied")}
                      style={{ cursor: "pointer" }}
                    >
                      Job Applied{" "}
                    </li>
                    <li
                      className={`ct_grey_text ${activeTab === "saved" ? "ct_fw_600 ct_darkblue_text active" : ""
                        }`}
                      onClick={() => setActiveTab("saved")}
                      style={{ cursor: "pointer" }}
                    >
                      Saved Jobs{" "}
                    </li>
                  </ul>
                  <div className="ct_job_apply_list_main ct_custom_scroll ct_mt_30">
                    {activeTab === "for_me" && jobsForMe?.length === 0 && (
                      <div className="text-center ct_grey_text py-4">
                        No jobs found.
                      </div>
                    )}
                    {activeTab === "applied" && (
                      <>
                        {appliedJobs?.length === 0 && (
                          <div className="text-center ct_grey_text py-4">
                            No applied jobs found.
                          </div>
                        )}
                        {appliedJobs?.length > 0 && (
                          <ul>
                            {appliedJobs.map((job, index) => {
                              const salaryRange =
                                job?.min_salary || job?.max_salary
                                  ? `${job?.salary_currency || ""}${job?.min_salary || ""}${job?.max_salary
                                    ? ` - ${job?.salary_currency || ""}${job?.max_salary}`
                                    : ""
                                  }`
                                  : "";
                              return (
                                <li
                                  key={job?.applied_id || job?.job_id || index}
                                  className="ct_job_card_v2"
                                >
                                  <div className="d-flex align-items-start justify-content-between gap-3 flex-wrap">
                                    <div>
                                      <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                        {job?.job_title || "#N/A"}
                                      </h4>
                                      <div className="ct_fs_14 ct_grey_text">
                                        {job?.company_name || "#N/A"}
                                        {job?.location
                                          ? ` - ${job?.location}`
                                          : ""}
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                      <button
                                        className="ct_btn_apply_v2"
                                        type="button"
                                        onClick={() => handleViewJob(job)}
                                      >
                                        View
                                      </button>
                                      <button
                                        className="ct_btn_bookmark_v2"
                                        type="button"
                                        onClick={() => handleSaveJob(job)}
                                        disabled={isLoading}
                                      >
                                        <i
                                          className={
                                            isJobSaved(job)
                                              ? "fa-solid fa-bookmark"
                                              : "fa-regular fa-bookmark"
                                          }
                                        ></i>
                                      </button>
                                    </div>
                                  </div>

                                  <div className="d-flex align-items-center gap-3 ct_mt_16 flex-wrap">
                                    {job?.candidate_availability && (
                                      <span className="ct_job_tag">
                                        {job?.candidate_availability}
                                      </span>
                                    )}
                                    {job?.candidate_location && (
                                      <span className="ct_job_tag">
                                        {job?.candidate_location}
                                      </span>
                                    )}
                                    {job?.years_of_experience && (
                                      <span className="ct_job_tag">
                                        {job?.years_of_experience} Years
                                      </span>
                                    )}
                                  </div>

                                  <div className="d-flex align-items-center gap-3 ct_mt_16 flex-wrap">
                                    {salaryRange && (
                                      <p className="ct_grey_text ct_fs_14 mb-0">
                                        {salaryRange}
                                      </p>
                                    )}
                                    {job?.posted_date && (
                                      <>
                                        <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                                        <p className="ct_grey_text ct_fs_14 mb-0">
                                          {pipViewDate2(job?.posted_date)}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </>
                    )}
                    {activeTab === "saved" && (
                      <>
                        {savedJobs?.length === 0 && (
                          <div className="text-center ct_grey_text py-4">
                            No saved jobs found.
                          </div>
                        )}
                        {savedJobs?.length > 0 && (
                          <ul>
                            {savedJobs.map((job, index) => {
                              const salaryRange =
                                job?.min_salary || job?.max_salary
                                  ? `${job?.salary_currency || ""}${job?.min_salary || ""}${job?.max_salary
                                    ? ` - ${job?.salary_currency || ""}${job?.max_salary}`
                                    : ""
                                  }`
                                  : "";
                              return (
                                <li
                                  key={job?.saved_id || job?.id || index}
                                  className="ct_job_card_v2"
                                >
                                  <div className="d-flex align-items-start justify-content-between gap-3 flex-wrap">
                                    <div>
                                      <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                        {job?.job_title || "#N/A"}
                                      </h4>
                                      <div className="ct_fs_14 ct_grey_text">
                                        {job?.company_name || "#N/A"}{" "}
                                        {job?.location
                                          ? ` - ${job?.location}`
                                          : ""}
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                      <button
                                        className="ct_btn_apply_v2"
                                        type="button"
                                        onClick={() => handleViewJob(job)}
                                      >
                                        Apply
                                      </button>
                                      <button
                                        className="ct_btn_bookmark_v2"
                                        type="button"
                                        onClick={() => handleSaveJob(job)}
                                        disabled={isLoading}
                                      >
                                        <i
                                          className={
                                            isJobSaved(job)
                                              ? "fa-solid fa-bookmark"
                                              : "fa-regular fa-bookmark"
                                          }
                                        ></i>
                                      </button>
                                    </div>
                                  </div>

                                  <div className="d-flex align-items-center gap-3 ct_mt_16 flex-wrap">
                                    {job?.candidate_availability && (
                                      <span className="ct_job_tag">
                                        {job?.candidate_availability}
                                      </span>
                                    )}
                                    {job?.candidate_location && (
                                      <span className="ct_job_tag">
                                        {job?.candidate_location}
                                      </span>
                                    )}
                                    {job?.years_of_experience && (
                                      <span className="ct_job_tag">
                                        {job?.years_of_experience} Years
                                      </span>
                                    )}
                                  </div>

                                  <div className="d-flex align-items-center gap-3 ct_mt_16 flex-wrap">
                                    {salaryRange && (
                                      <p className="ct_grey_text ct_fs_14 mb-0">
                                        {salaryRange}
                                      </p>
                                    )}
                                    {job?.posted_date && (
                                      <>
                                        <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                                        <p className="ct_grey_text ct_fs_14 mb-0">
                                          {pipViewDate2(job?.posted_date)}
                                        </p>
                                      </>
                                    )}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </>
                    )}
                    {activeTab === "for_me" && jobsForMe?.length > 0 && (
                      <ul>
                        {jobsForMe.map((job, index) => {
                          const salaryRange =
                            job?.min_salary || job?.max_salary
                              ? `${job?.salary_currency || ""}${job?.min_salary || ""}${job?.max_salary
                                ? ` - ${job?.salary_currency || ""}${job?.max_salary}`
                                : ""
                              }`
                              : "";
                          return (
                            <li key={job?.id || index} className="ct_job_card_v2">
                              <div className="d-flex align-items-start justify-content-between gap-3 flex-wrap">
                                <div>
                                  <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                    {job?.job_title || "#N/A"}
                                  </h4>
                                  <div className="ct_fs_14 ct_grey_text">
                                    {job?.company_name || "#N/A"}{" "}
                                    {job?.location ? ` - ${job?.location}` : ""}
                                  </div>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                  <button
                                    className="ct_btn_apply_v2"
                                    type="button"
                                    onClick={() => handleViewJob(job)}
                                  >
                                    Apply
                                  </button>
                                  <button
                                    className="ct_btn_bookmark_v2"
                                    type="button"
                                    onClick={() => handleSaveJob(job)}
                                    disabled={isLoading}
                                  >
                                    <i
                                      className={
                                        isJobSaved(job)
                                          ? "fa-solid fa-bookmark"
                                          : "fa-regular fa-bookmark"
                                      }
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              <div className="d-flex align-items-center gap-3 ct_mt_16 flex-wrap">
                                {job?.candidate_availability && (
                                  <span className="ct_job_tag">
                                    {job?.candidate_availability}
                                  </span>
                                )}
                                {job?.candidate_location && (
                                  <span className="ct_job_tag">
                                    {job?.candidate_location}
                                  </span>
                                )}
                                {job?.years_of_experience && (
                                  <span className="ct_job_tag">
                                    {job?.years_of_experience} Years
                                  </span>
                                )}
                              </div>

                              <div className="d-flex align-items-center gap-3 ct_mt_16 flex-wrap">
                                {salaryRange && (
                                  <p className="ct_grey_text ct_fs_14 mb-0">
                                    {salaryRange}
                                  </p>
                                )}
                                {job?.posted_date && (
                                  <>
                                    <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                                    <p className="ct_grey_text ct_fs_14 mb-0">
                                      {pipViewDate2(job?.posted_date)}
                                    </p>
                                  </>
                                )}
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                  {/* Job Applied Section E */}

                  {/* Empty Div Section S */}
                  <div className="ct_empty_job_section d-none">
                    <img src="../assets/img/start_looking_job_img.png" />
                    <div className="mt-4 text-center">
                      <h4 className="ct_fs_24 ct_darkblue_text mb-2">
                        Ahh... We’re sorrry
                      </h4>
                      <h4 className="ct_fs_24 ct_darkblue_text mb-2">
                        You have not applied to any job yet
                      </h4>
                      <p className="ct_fs_16 ct_darkblue_text mb-0">
                        Don’t worry. We are here to help you, you can start
                        matching your dream jobs.
                      </p>
                      <div className="ct_mt_30 text-center">
                        <button className="ct_yellow_btn mx-auto">
                          Start Looking for Jobs
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* Empty Div Section E */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}

        <div
          className="modal modal-lg ct_congratulation_modal_fade"
          id="ct_schedule_meeting"
          tabIndex="-1"
        >
          <div
            className="modal-dialog modal-dialog-centered ct_modal-dialog"
            style={{ maxWidth: "500px" }}
          >
            <div className="modal-content ct_border_radius_20">
              <div className="modal-header border-0">
                <button
                  type="button"
                  className="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                ></button>
              </div>
              <div className="modal-body  pt-0 ct_p_30">
                <div>
                  <h4 className="ct_fs_16 mb-2 ct_darkblue_text">
                    Schedule Interview
                  </h4>
                  <p className="mb-0 ct_fs_12 ct_grey_text">
                    Select a time to connect with the project owner
                  </p>
                </div>
                <ul className="ct_mt_30 ">
                  <li className="ct_dtl_grid_2">
                    <p className="ct_fs_12 ct_darkblue_text mb-0 ct_white_nowrap">
                      Job Title :
                    </p>
                    <p className="ct_fs_12 ct_grey_text mb-0">
                      Landing Page Redesign
                    </p>
                  </li>
                  <li className="ct_dtl_grid_2 ct_mt_10">
                    <p className="ct_fs_12 ct_darkblue_text mb-0 ct_white_nowrap">
                      Client:
                    </p>
                    <p className="ct_fs_12 ct_grey_text mb-0">
                      Nuvio Enterprises
                    </p>
                  </li>
                  <li className="ct_dtl_grid_2 ct_mt_10">
                    <p className="ct_fs_12 ct_darkblue_text mb-0 ct_white_nowrap">
                      Preferred Format :
                    </p>
                    <p className="ct_fs_12 ct_grey_text mb-0">
                      Video Call (Google Meet)
                    </p>
                  </li>
                  <li className="ct_dtl_grid_2 ct_mt_10">
                    <p className="ct_fs_12 ct_darkblue_text mb-0 ct_white_nowrap">
                      Duration :
                    </p>
                    <p className="ct_fs_12 ct_grey_text mb-0">30 Minutes</p>
                  </li>
                </ul>
                <form className="ct_modal_scroll ct_custom_scroll  pb-3 pt-3 ">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="ct_fs_12 ct_darkblue_text mb-2">
                          Date Picker
                        </label>
                        <input
                          type="date"
                          className="form-control ct_fs_12 ct_input"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-4">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Available Time Slot
                        </label>
                        <input
                          type="time"
                          className="form-control ct_fs_12 ct_input"
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Message (Optional)
                        </label>
                        <textarea
                          className="form-control ct_input h-auto ct_fs_12"
                          rows={4}
                          placeholder="Hi, looking forward to discussing how i will approach the redesign"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 justify-content-center pt-4 ct_flex_col_575">
                    <button
                      className="ct_sky_blue_btn ct_fs_14 ct_yellow_btn ct_outline_grey  px-5 py-2 ct_w_100_575"
                      style={{ borderColorL: "#53586252" }}
                      type="button"
                    >
                      Cancel
                    </button>
                    <button
                      className=" ct_yellow_btn px-5 ct_fs_14 py-2 ct_w_100_575"
                      type="button"
                      data-bs-target="#ct_submit_modal"
                      data-bs-toggle="modal"
                    >
                      Confirm & Schedule
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </FreelancerLayout>

      <div
        className="modal modal-xl ct_congratulation_modal_fade"
        id="ct_job_details_modal"
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered ct_modal-dialog"
          style={{ maxWidth: "930px" }}
        >
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close ct_circle_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-sm-5 px-3 pt-0 pb-5">
              <div className="row">
                <div className="col-xl-12">
                  <div className="">
                    <div className="d-flex align-items-start justify-content-between gap-3 ct_flex_col_1199  ct_mb_60">
                      <div>
                        <h4 className="ct_fs_32 mb-0 ct_darkblue_text">
                          UI/UX Designer
                        </h4>
                        <div className="d-flex align-items-center gap-3  mt-4 ct_flex_col_575">
                          <div
                            class="ct_feature_job_icon"
                            style={{ width: "80px", height: "80px" }}
                          >
                            <img src="../assets/img/Featured_Jobs_icon_1.svg" />
                          </div>
                          <div>
                            <div className="d-flex align-items-center gap-3 ">
                              <h4 className="ct_fs_18 mb-0 ct_darksky_blue_text">
                                CodeNest{" "}
                              </h4>
                              <div class="ct_fs_14 d-flex align-items-center gap-1">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                London, England
                              </div>
                            </div>
                            <div class="d-flex align-items-center gap-4 ct_mt_20 flex-wrap">
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                Full-Time
                              </span>
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                Remote
                              </span>
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                2-4 Years
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center  gap-3 ct_flex_col_575 ct_w_100_575">
                        <button
                          className="ct_yellow_btn ct_light_red_btn  ct_white_nowrap ct_border_radius_20 ct_h_44 px-4 ct_w_100_575"
                          data-bs-target="#ct_cancel_application"
                          data-bs-toggle="modal"
                        >
                          Cancel Application
                        </button>
                        <button
                          className="ct_yellow_btn ct_sky_blue_btn ct_white_nowrap ct_border_radius_20 ct_h_44 px-4 ct_w_100_575"
                          data-bs-target="#ct_schedule_meeting"
                          data-bs-toggle="modal"
                        >
                          Schedule Meeting
                        </button>
                      </div>
                    </div>

                    <div className="">
                      <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                        Your Application
                      </h4>
                      <ul
                        className="ps-4 ct_para_scroll ct_custom_scroll"
                        style={{ listStyle: "disc" }}
                      >
                        <li className="ct_fs_20_new ct_darkblue_text">
                          Applied Date : June 10, 2025
                        </li>
                        <li className="ct_fs_20_new ct_darkblue_text mt-1">
                          Application Status:{" "}
                          <spa class="ct_orange_text">Shortlisted</spa>
                        </li>
                        <li className="ct_fs_20_new ct_darkblue_text mt-1">
                          Budget: $2000
                        </li>
                        <li className="ct_fs_20_new ct_darkblue_text mt-1">
                          Timeline: 5 Months
                        </li>
                        <li className="ct_fs_20_new ct_darkblue_text mt-1">
                          Attached Files: Portfolio Link & Resume
                        </li>
                      </ul>
                    </div>
                    <div className="ct_mt_40">
                      <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                        About this role
                      </h4>
                      <p
                        className="ct_fs_20_new ct_para_scroll ct_custom_scroll ct_darkblue_text"
                        style={{ maxWidth: "820px" }}
                      >
                        As a UI/UX designer on CodeNest, you’ll focus on design
                        user- friendly on several platform (web, mobile,
                        dashboards, etc) to our user needs. Your innovation
                        solution will enhance the user experience on several
                        platforms. Join us and let’s making impact on user
                        engagement at CodeNest.
                      </p>
                    </div>
                  </div>
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Responsibility
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      <li className="ct_fs_20_new ct_darkblue_text">
                        Create design and user journey on every features and
                        product/business units across multiple devices (Web
                        +App)
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Identifying design problems through user journey and
                        devising elegant solutions
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Develop low and hi fidelity designs, user experience
                        flow, & prototype, translate it into highly- polished
                        visual composites following style and brand guidelines
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Brainstorm and works together with Design Lead, UX
                        Engineers, and PMS to execute a design sprint on
                        specific story or task
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade ct_suspend_account"
        id="ct_cancel_application"
        tabindex="-1"
        aria-labelledby="ct_cancel_applicationLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body py-5">
              <div class="mx-auto d-block text-center ct_mb_20">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 44V8C4 6.9 4.392 5.95867 5.176 5.176C5.96 4.39333 6.90133 4.00133 8 4H40C41.1 4 42.042 4.392 42.826 5.176C43.61 5.96 44.0013 6.90133 44 8V32C44 33.1 43.6087 34.042 42.826 34.826C42.0433 35.61 41.1013 36.0013 40 36H12L4 44ZM24 30C24.5667 30 25.042 29.808 25.426 29.424C25.81 29.04 26.0013 28.5653 26 28C25.9987 27.4347 25.8067 26.96 25.424 26.576C25.0413 26.192 24.5667 26 24 26C23.4333 26 22.9587 26.192 22.576 26.576C22.1933 26.96 22.0013 27.4347 22 28C21.9987 28.5653 22.1907 29.0407 22.576 29.426C22.9613 29.8113 23.436 30.0027 24 30ZM22 22H26V10H22V22Z"
                    fill="#023047"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_20 mb-2">Cancel Job Application</h4>
                <p className="mb-0 ct_grey_text">
                  Withdraw your application for this job opportunity
                </p>
              </div>
              <div class="text-center ct_mt_30 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                <button
                  class="ct_yellow_btn ct_outline_grey ct_h_48 w-100 px-5 ct_w_100_575"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button class="ct_yellow_btn ct_h_48 mx-auto px-5 w-100 ct_w_100_575 ct_red_btn">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade ct_submit_modal"
        id="ct_submit_modal"
        tabindex="-1"
        aria-labelledby="ct_submit_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body py-5">
              <div class="mx-auto d-block text-center ct_mb_20">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_18 ">This Meeting is Scheduled</h4>
                <p
                  className="ct_fs-14 ct_grey_text mb-0 mx-auto"
                  style={{ maxWidth: "300px" }}
                >
                  Meeting request sent! You will receive a confirmation once it
                  is approved
                </p>
              </div>
              <div class="text-center ct_mt_30 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                <button
                  class="ct_yellow_btn ct_h_48 ct_outline_grey  px-5 ct_w_100_575"
                  data-bs-dismiss="modal"
                >
                  Close{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal modal-xl ct_congratulation_modal_fade"
        id="ct_job_details_modal_2"
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered ct_modal-dialog"
          style={{ maxWidth: "1440px" }}
        >
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close ct_circle_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-sm-5 px-3 pt-0 pb-5">
              <div className="row">
                <div className="col-xl-8 col-lg-8 mb-4 mb-lg-0">
                  <div className="">
                    <div className="d-flex align-items-start justify-content-between gap-3 ct_flex_col_1199  ct_mb_60">
                      <div>
                        <h4 className="ct_fs_32 mb-0 ct_darkblue_text">
                          UI/UX Designer
                        </h4>
                        <div className="d-flex align-items-center gap-3  mt-4 ct_flex_col_575">
                          <div
                            class="ct_feature_job_icon"
                            style={{ width: "80px", height: "80px" }}
                          >
                            <img src="../assets/img/Featured_Jobs_icon_1.svg" />
                          </div>
                          <div>
                            <div className="d-flex align-items-center gap-3 ">
                              <h4 className="ct_fs_18 mb-0 ct_darksky_blue_text">
                                CodeNest{" "}
                              </h4>
                              <div class="ct_fs_14 d-flex align-items-center gap-1">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                    fill="#023047"
                                  ></path>
                                </svg>
                                London, England
                              </div>
                            </div>
                            <div class="d-flex align-items-center gap-4 ct_mt_20 flex-wrap">
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                Full-Time
                              </span>
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                Remote
                              </span>
                              <span
                                class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                                style={{
                                  backgroundColor: "hsl(0deg 0% 93% / 50%)",
                                }}
                              >
                                2-4 Years
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center  gap-3 ">
                        <button
                          className="ct_yellow_btn ct_sky_blue_btn ct_white_nowrap ct_border_radius_20 ct_h_44 px-5"
                          data-bs-target="#ct_aaply_for_job"
                          data-bs-toggle="modal"
                        >
                          Apply Now
                        </button>
                        <div className="ct_icon_heart_50">
                          <i class="fa-regular fa-bookmark ct_darkblue_text"></i>
                        </div>
                        <div className="ct_icon_heart_50">
                          <i class="fa-solid fa-share-nodes ct_darkblue_text"></i>
                        </div>
                      </div>
                    </div>
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      About this role
                    </h4>
                    <p
                      className="ct_fs_20_new ct_para_scroll ct_custom_scroll ct_darkblue_text"
                      style={{ maxWidth: "820px" }}
                    >
                      As a UI/UX designer on CodeNest, you’ll focus on design
                      user- friendly on several platform (web, mobile,
                      dashboards, etc) to our user needs. Your innovation
                      solution will enhance the user experience on several
                      platforms. Join us and let’s making impact on user
                      engagement at CodeNest.
                    </p>
                  </div>
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Qualification
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      <li className="ct_fs_20_new ct_darkblue_text">
                        At least 2-4 years of relevant experience in product
                        design or related roles.
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Knowledge of design validation, either through
                        quantitative or qualitative research.
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Have good knowledge using Figma and Figjam
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Experience with analytics tools to gather data from
                        users
                      </li>
                    </ul>
                  </div>
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Responsibility
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      <li className="ct_fs_20_new ct_darkblue_text">
                        Create design and user journey on every features and
                        product/business units across multiple devices (Web
                        +App)
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Identifying design problems through user journey and
                        devising elegant solutions
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Develop low and hi fidelity designs, user experience
                        flow, & prototype, translate it into highly- polished
                        visual composites following style and brand guidelines
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Brainstorm and works together with Design Lead, UX
                        Engineers, and PMS to execute a design sprint on
                        specific story or task
                      </li>
                    </ul>
                  </div>
                  <div className="ct_mt_40">
                    <h4 className="ct_fs_24_new ct_mb_20 ct_darkblue_text">
                      Requirement
                    </h4>
                    <ul
                      className="ps-4 ct_para_scroll ct_custom_scroll"
                      style={{ listStyle: "disc" }}
                    >
                      <li className="ct_fs_20_new ct_darkblue_text">
                        Proven work experience as a UI/UX Designer or similar
                        role
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Strond portfolio of design projects (web/ mobile)
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Proficiency in design and prototyping tools such as
                        Figma, Adobe XD, Sketch, or similar
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Good understanding of HTML/CSS (Knowledge of front-end
                        development is a plus)
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Ability to think creatively and deliver within deadlines
                      </li>
                      <li className="ct_fs_20_new ct_darkblue_text mt-1">
                        Excellent communication and teamwork skills
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-4 mb-4 mb-lg-0 ps-lg-5">
                  <div>
                    <h4 className="ct_fs_24_new mb-4">Similar Jobs</h4>
                    <ul>
                      <li>
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="../assets/img/Featured_Jobs_icon_6.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Lead UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="../assets/img/Featured_Jobs_icon_3.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Sr. UX Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="../assets/img/Featured_Jobs_icon_2.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Jr. UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="ct_mt_56">
                    <h4 className="ct_fs_24_new mb-4">
                      Other Jobs From CodeNest
                    </h4>
                    <ul>
                      <li>
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="../assets/img/Featured_Jobs_icon_1.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Lead UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="../assets/img/Featured_Jobs_icon_1.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Sr. UX Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="ct_mt_20">
                        <div class="ct_simillar_job_card gap-3">
                          <div className="d-flex align-items-center justify-content-between gap-2">
                            <div className="d-flex align-items-center gap-3">
                              <div class="ct_feature_job_icon">
                                <img src="../assets/img/Featured_Jobs_icon_1.svg" />
                              </div>
                              <div>
                                <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                                  Jr. UI Designer
                                </h4>
                                <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                                  <li className="ct_fs_14">CodeNest</li>
                                  <li className="ct_fs_14">
                                    <svg
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                        fill="#023047"
                                      />
                                    </svg>
                                    London, England
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="ct_bookmark_circle">
                              <svg
                                width="34"
                                height="34"
                                viewBox="0 0 34 34"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                                  stroke="#023047"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <circle
                                  cx="16.6667"
                                  cy="16.6667"
                                  r="16.1667"
                                  stroke="#535862"
                                />
                              </svg>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Full-Time
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              Remote
                            </span>
                            <span
                              class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                              style={{
                                backgroundColor: "hsl(0deg 0% 93% / 50%)",
                              }}
                            >
                              2-4 Years
                            </span>
                          </div>

                          <div className="d-flex align-items-center gap-3">
                            <p className="ct_grey_text  ct_fs_14 mb-0">
                              2 day ago{" "}
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              120 Applicants
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {activeApplyJob && (
        <div className="modal modal-lg ct_congratulation_modal_fade d-block">
          <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <div>
                  <h4 className="ct_fs_32 ct_darkblue_text mb-1">
                    {activeApplyJob?.job_title || "Job Application"}
                  </h4>
                  <p className="mb-0 ct_grey_text">
                    {activeApplyJob?.company_name || "#N/A"}{" "}
                    {activeApplyJob?.location
                      ? ` - ${activeApplyJob?.location}`
                      : ""}
                  </p>
                </div>
                <button
                  type="button"
                  className="btn-close ct_circle_close"
                  onClick={() => setActiveApplyJob(null)}
                ></button>
              </div>
              <div className="modal-body px-0 ct_mt_40 pt-0">
                {isLoading && <Loader />}
                <Formik
                  initialValues={getApplyInitialValues()}
                  validationSchema={applyJobSchema}
                  onSubmit={(values) => handleSubmitApplyJob(values)}
                  enableReinitialize
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setTouched,
                  }) => (
                    <form className="ct_modal_scroll ct_custom_scroll px-4 pb-3 ">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group mb-4">
                            <label className="ct_fs_14 ct_darkblue_text mb-2">
                              Full Name
                            </label>
                            <input
                              type="text"
                              className="form-control ct_input"
                              placeholder="e.g"
                              name="full_name"
                              value={values.full_name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="full_name"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label className="ct_fs_14 ct_darkblue_text mb-2">
                              Email Address
                            </label>
                            <input
                              type="text"
                              className="form-control ct_input"
                              placeholder="Email address"
                              name="email"
                              value={values.email}
                              readOnly
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label className="ct_fs_14 ct_darkblue_text mb-2">
                              Phone Number
                            </label>
                            <PhoneInput
                              id="phone_number"
                              className="ct_phone_input"
                              defaultCountry="MU"
                              value={values.phone_number}
                              onChange={(val) => {
                                setFieldValue("phone_number", val ?? "");
                              }}
                              onBlur={() =>
                                setTouched({ ...touched, phone_number: true })
                              }
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="phone_number"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label className="ct_fs_14 ct_darkblue_text mb-2">
                              Expected Salary (in local currency)
                            </label>
                            <input
                              type="number"
                              className="form-control ct_input"
                              placeholder="Expected salary"
                              name="expected_salary"
                              value={values.expected_salary}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="expected_salary"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-4">
                            <label className="ct_fs_14 ct_darkblue_text mb-2">
                              Work
                            </label>
                            <div className="d-flex flex-column gap-2 position-relative">
                              <select
                                className="form-control ct_input"
                                name="work_type"
                                value={values.work_type}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              >
                                <option value="">Select Work</option>
                                {workOptions.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                            </div>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="work_type"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group mb-4">
                            <label className="ct_fs_14 ct_darkblue_text mb-2">
                              Current Position (if unemployed, then “Unemployed”)
                            </label>
                            <input
                              type="text"
                              className="form-control ct_input"
                              placeholder="Current position"
                              name="current_position"
                              value={values.current_position}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="current_position"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group mb-4">
                            <label className="ct_fs_14 ct_darkblue_text mb-2">
                              Linkedin Profile Link
                            </label>
                            <input
                              type="text"
                              className="form-control ct_input"
                              placeholder="Link"
                              name="linkedin_url"
                              value={values.linkedin_url}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="linkedin_url"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group mb-4">
                            <label className="ct_fs_14 ct_darkblue_text mb-2">
                              Porfolio Link
                            </label>
                            <input
                              type="text"
                              className="form-control ct_input"
                              placeholder="Link"
                              name="portfolio_url"
                              value={values.portfolio_url}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="portfolio_url"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group mb-4">
                            <label className="ct_fs_14 ct_darkblue_text mb-2">
                              Cover Letter
                            </label>
                            <textarea
                              className="form-control ct_input h-auto"
                              rows={4}
                              placeholder="Type here..."
                              name="cover_letter"
                              value={values.cover_letter}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            ></textarea>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="cover_letter"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group mb-4">
                            <label className="ct_fs_14 ct_darkblue_text mb-2">
                              Upload Resume
                            </label>
                            <PdfOrImageUploader
                              maxFiles={1}
                              multiple={false}
                              acceptType="application/pdf,.pdf"
                              placeholder="Upload CV (PDF only)"
                              replaceOnSelect={true}
                              existingFiles={
                                values?.resume_files &&
                                  Array.isArray(values.resume_files)
                                  ? values.resume_files.map((file, idx) => ({
                                    id: file?.id || idx,
                                    file: file,
                                    name:
                                      file?.name ||
                                      (typeof file === "string"
                                        ? file.split("/").pop()
                                        : `cv-${idx + 1}.pdf`),
                                    type: "pdf",
                                    preview:
                                      typeof file === "string"
                                        ? file
                                        : file?.preview || file?.url || "",
                                    isExisting: !(file instanceof File),
                                  }))
                                  : []
                              }
                              onChange={(newFiles) => {
                                setTouched({ resume_files: true });
                                setFieldValue("resume_files", newFiles);
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="resume_files"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3 justify-content-end pt-4">
                        <button
                          className="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 py-2"
                          style={{ borderColorL: "#53586252" }}
                          type="button"
                          onClick={() => setActiveApplyJob(null)}
                        >
                          Cancel
                        </button>
                        <button
                          className="ct_sky_blue_btn ct_yellow_btn px-5 py-2"
                          type="button"
                          onClick={handleSubmit}
                          disabled={isLoading}
                        >
                          {isLoading ? "Submitting..." : "Submit"}
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      )}
      {activeJob && (
        <FreelancerJobDetailsModal
          isOpen={!!activeJob}
          onClose={() => setActiveJob(null)}
          job={activeJob}
          similarJobs={similarJobs}
          onSave={handleSaveJob}
          isSaving={isLoading}
          onSelectJob={(job) => {
            handleViewJob(job);
          }}
          onApply={(job) => {
            setActiveApplyJob(job);
          }}
          onScheduleAction={handleScheduleAction}
        />
      )}
    </div>
  );
}

export default MyJob


